import { motion, Variants } from "framer-motion";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";

const iconVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.8,
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      delay: i * 0.1,
      duration: 0.4,
      ease: "easeOut",
    },
  }),
};

const FloatingSocial = () => {
  const icons = [
    {
      icon: <FaWhatsapp />,
      link: "https://wa.me/919844606132",
      color: "bg-green-500",
      glow: "shadow-[0_0_15px_rgba(34,197,94,0.7)]",
      label: "WhatsApp",
    },
    {
      icon: <FaPhoneAlt />,
      link: "tel:+919844606132",
      color: "bg-blue-600",
      glow: "shadow-[0_0_15px_rgba(37,99,235,0.7)]",
      label: "Call",
    },
    {
      icon: <FaFacebookF />,
      link: "https://www.facebook.com/profile.php?id=61573681677505",
      color: "bg-[#1877F2]",
      glow: "shadow-[0_0_15px_rgba(24,119,242,0.7)]",
      label: "Facebook",
      hideOnMobile: true,
    },
    {
      icon: <FaInstagram />,
      link: "https://www.instagram.com/prores_scientific/",
      color:
        "bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600",
      glow: "shadow-[0_0_15px_rgba(236,72,153,0.7)]",
      label: "Instagram",
      hideOnMobile: true,
    },
  ];

  return (
    <div className="fixed bottom-4 right-4 z-[99] flex flex-col gap-3 sm:gap-4">
      {icons.map((item, index) => (
        <motion.a
          key={item.label}
          custom={index}
          variants={iconVariants}
          initial="hidden"
          animate="visible"
          whileHover={{
            scale: 1.15,
            rotate: 5,
          }}
          whileTap={{ scale: 0.9 }}
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          className={`
            flex items-center justify-center
            rounded-full text-white
            ${item.color}
            ${item.hideOnMobile ? "hidden sm:flex" : ""}
            w-11 h-11 text-lg
            transition-shadow duration-300
            hover:${item.glow}
          `}
        >
          {item.icon}
        </motion.a>
      ))}
    </div>
  );
};

export default FloatingSocial;
